import { Timer } from 'three';

/**
 * Boucle de rendu.
 *
 * `Timer` remplace `Clock`, deprecie depuis r18x : il se branche sur la Page
 * Visibility API, donc revenir d'un autre onglet ne produit pas un delta de
 * trente secondes. On borne quand meme : une frame tres longue ferait
 * traverser un merlon au char et teleporterait les obus.
 * cf. doc/06-boucle-de-jeu-et-perf.md
 */
export class Loop {
  private readonly timer = new Timer();
  private handle = 0;
  private running = false;
  private elapsed = 0;

  constructor(private readonly onFrame: (dt: number, elapsed: number) => void) {
    this.timer.connect(document);
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    const tick = (timestamp: number) => {
      if (!this.running) return;
      this.handle = requestAnimationFrame(tick);
      this.timer.update(timestamp);
      const dt = Math.min(this.timer.getDelta(), 1 / 20);
      this.elapsed += dt;
      this.onFrame(dt, this.elapsed);
    };
    this.handle = requestAnimationFrame(tick);
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.handle);
  }

  dispose(): void {
    this.stop();
    this.timer.dispose();
  }
}
